$(document).ready(function() {

    // Alter the address form based on the address type
    const privateAddress = function() {
        // Check the is_private_address radio button.
        let types = document.getElementsByName("is_private_address");

        types.forEach(type => {
            if (type.checked) {
                let first_name = document.getElementById("first_name");
                let last_name = document.getElementById("last_name");
                let company_name = document.getElementById("company_name");

                // Private address
                // Company field to be required
                if (type.value == 1) {
                    first_name.required = true;
                    last_name.required = true;
                    company_name.required = false;
                }

                // Company address
                // Name fields to be required
                if (type.value == 0) {
                    first_name.required = false;
                    last_name.required = false;
                    company_name.required = true;
                }
            }
        });
    }

    // Set up the private address listeners
    const privateAddressSetUp = function() {
        let addressTypes = document.getElementsByName("is_private_address");

        addressTypes.forEach(el => {
            el.addEventListener('change', function (e) {
                e.preventDefault();
                privateAddress();
            },false);
        });
    }

    var element = document.getElementById("is_private_address");

    // If it isn't "undefined" and it isn't "null", then it exists.
    // The Private address logic is just for the Nordics.
    if(typeof(element) != 'undefined' && element != null){
        privateAddress();
        privateAddressSetUp();
    }

    // Telephone international codes
    var input = document.querySelector(".js-international_tel");

    // Check .js-international_tel exists
    if (typeof input != 'undefined' && input != null) {

        var preferredCountries = input.getAttribute('data-preferredCountries');

        if (typeof preferredCountries === 'undefined' || preferredCountries === null) {
            preferredCountries = ['gb', 'de', 'fr'];
        } else {
            preferredCountries = preferredCountries.split(",");
        }

        var iti = window.intlTelInput(input, {
            hiddenInput: "full_contact_number",
            preferredCountries: preferredCountries,
            nationalMode: true,
            geoIpLookup: function(callback) {
                $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "us";
                    callback(countryCode);
                });
            },
            utilsScript: "/js/utils.js?1613236686837" // just for formatting/placeholders etc
        });

        // On country change update the telephone code.
        var addressDropdown = document.querySelector("[name='country_id']");

        // listen to the country_id dropdown for changes
        addressDropdown.addEventListener('change', function() {
            iti.setCountry(this.options[this.selectedIndex].getAttribute('data-iso2'));
        });
    }

    // Get the forms we want to add validation styles to
    var forms = document.getElementsByClassName('js-postcode-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }

            // Get the postcode field
            let postcodeElement = document.getElementById("postcode");
            // Get the postcode value
            let postcode = postcodeElement.value;
            // Get the selected country
            let selCountryId = document.getElementById("country_id");
            // Get the selected country_id
            let countryId = selCountryId.options[selCountryId.selectedIndex].value;
            // Get the countries postcode regex
            postcode_regex = countryPostcodeRegex[countryId];

            // Test the postcode against the postcode regex
            let validPostcode = postcode_regex.test(postcode);

            // Add is-invalid class to postcode element if regex fails
            if (!validPostcode) {
                event.preventDefault();
                event.stopPropagation();
                postcodeElement.classList.add('is-invalid');
                let postcode_example = selCountryId.options[selCountryId.selectedIndex].dataset.postcode_example;
                let country_text = selCountryId.options[selCountryId.selectedIndex].text;

                let postcodeExamples = document.getElementsByClassName("js-postcode_example");
                for (let i = 0; i < postcodeExamples.length; i++) {
                    console.log(postcode_example);
                    postcodeExamples[i].innerHTML = postcode_example + " (" + country_text + ")";
                }
            } else {
                postcodeElement.classList.remove("is-invalid");
            }

            //form.classList.add('was-validated');
        }, false);
    });
});